// extracted by mini-css-extract-plugin
module.exports = {"page":"SetPassPage_page__4r-_B page_page__31uF2"};